(() => {
  'use strict';
  const entry = document.querySelector('.editorial-header .button');
  if (!entry) return;
  const audience = document.body.dataset.portraitAudience;
  const targets = [...document.querySelectorAll('a[href$="#preview"]')];
  if (audience) for (const link of targets) {
    const url = new URL(link.href);
    if (url.origin !== location.origin) continue;
    url.searchParams.set('audience', audience);
    link.href = url.href;
  }
  const bar = document.createElement('div');
  bar.className = 'editorial-preview-sticky';
  bar.hidden = true;
  const action = entry.cloneNode(true);
  bar.append(action);
  document.body.append(bar);
  let scheduled = false;
  const update = () => {
    scheduled = false;
    const typing = /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '');
    const visible = targets.some(link => {
      const r = link.getBoundingClientRect();
      return r.width > 0 && r.top >= 0 && r.bottom <= innerHeight;
    });
    bar.hidden = visible || typing || scrollY < 120;
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule);
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  update();
})();
